import { Roles } from "@/helpers/enums/Roles";

export default [
  {
    path: "hash-lookup",
    component: () => import("@/views/pages/Settings/VersionControl.vue"),
    meta: {
      title: "settings",
    },
  },
  {
    path: "syslog-settings",
    component: () => import("@/views/pages/Settings/SyslogSettings.vue"),
    meta: {
      title: "settings",
    },
  },
  {
    path: "smtp-settings",
    component: () => import("@/views/pages/Settings/SmtpSettings.vue"),
    meta: {
      title: "settings",
    },
  },
  {
    path: "sso-settings",
    component: () => import("@/views/pages/Settings/SSOSettings.vue"),
    meta: {
      title: "SSO settings",
    },
  },
  {
    path: "sso-settings/new",
    component: () => import("@/views/pages/Settings/CreateSSO.vue"),
    meta: {
      title: "SSO settings",
    },
  },
  {
    path: "pdp-lrp-list",
    component: () => import("@/views/pages/Settings/PdpLrpList.vue"),
    meta: {
      title: "pdpLrpConfiguration",
    },
    beforeEnter: () => {
      const selectedRole = localStorage.getItem("selectedRole");
      if (selectedRole === Roles.PartnerAdmin) {
        return { path: "/settings/pdp-lrp-settings" };
      }
      return true;
    }
  },
  {
    path: "pdp-lrp-settings",
    component: () => import("@/views/pages/Settings/PdpLrpSettings.vue"),
    meta: {
      title: "pdpLrpConfiguration",
    },
  },
  {
    path: "admin-mode-settings",
    meta: {
      title: "adminModeSettings",
      target: process.env.VUE_APP_AGMS_URL + "/Administration/Administrator/AgentSettings#adminModeSettings",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "installation-settings",
    meta: {
      title: "installationSettings",
      target: process.env.VUE_APP_AGMS_URL + "/Administration/Administrator/AgentSettings#installationSettings",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "agent-settings",
    meta: {
      title: "agentSettings",
      target: process.env.VUE_APP_AGMS_URL + "/Administration/Administrator/AgentSettings",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
];
